import styles from "./BrandCarousel.module.scss";
import { Entry } from "contentful";
import {
  ContentSection,
  PageSection,
} from "@tiicker/util/lib/contentful/types";
import { compact } from "lodash";
import {
  getImageReference,
  getItemReference,
} from "@tiicker/util/lib/contentful/helpers";
import BrandTile from "components/BrandTile/BrandTile";
import SwiperCarousel from "components/Carousel/SwiperCarousel";

interface Props {
  brandSlider: Entry<PageSection>;
  content: Entry<ContentSection>[] | undefined;
  includes?: any;
}

const BrandCarousel = (props: Props) => {
  const content = props.content && props.content[0];
  const brands = content?.fields.brands || [];
  const brandRefs = compact(
    brands.map((x) => getItemReference(x, props.includes))
  );

  return (
    <div className={styles.brandsCarousel}>
      <SwiperCarousel
        slides={brandRefs.map((brand) => {
          const heroImage = getImageReference(
            brand.fields.heroImage,
            props.includes
          );
          return (
            <div
              key={`brandCarousel__${brand.sys.id}`}
              className={styles.brandsCarousel__item}
            >
              <BrandTile
                brand={brand}
                backgroundImageUrl={heroImage?.fields.file.url}
              />
            </div>
          );
        })}
        slideClass={styles.brandsCarousel__item}
        spaceBetween={24}
        pagination
        navigation
        openSide="right"
      />
    </div>
  );
};

export default BrandCarousel;
